import { FOCUS_RING_SELECTION_BAR } from './focusRing';

/** A `value + label` pair, e.g. `{ value: 3, label: 'Added' }`. */
export interface SelectionBarCount {
    value: string | number;
    label: string;
}

export type SelectionBarEmphasis = 'primary' | 'secondary' | 'quiet';

export const PILL_TRANSITION_MS = 180;

export const PILL_TRACK_CLASS = 'malachite-selection-bar-track';
export const PILL_BUTTON_CLASS = 'malachite-selection-bar-btn';
export const PILL_SHEET_ID = 'malachite-selection-bar';

export const PILL_SHEET_CSS = `
.${PILL_TRACK_CLASS} {
    transition: opacity ${PILL_TRANSITION_MS}ms ease-out;
}
@media (prefers-reduced-motion: reduce) {
    .${PILL_TRACK_CLASS} {
        transition: none;
    }
}
.${PILL_BUTTON_CLASS}--primary {
    background-color: var(--malachite-selection-bar-foreground);
    color: var(--malachite-selection-bar-background);
    border: 1px solid var(--malachite-selection-bar-primary-border);
    box-shadow: var(--malachite-shadow-default, 0px 1px 0px 0px rgba(0, 0, 0, 0.15));
}
.${PILL_BUTTON_CLASS}--primary:hover:not(:disabled) {
    background-image: linear-gradient(
        color-mix(in srgb, var(--malachite-selection-bar-foreground) 88%, var(--malachite-selection-bar-background)),
        color-mix(in srgb, var(--malachite-selection-bar-foreground) 88%, var(--malachite-selection-bar-background))
    );
}
.${PILL_BUTTON_CLASS}--secondary {
    background-color: var(--malachite-selection-bar-divider);
    background-image: linear-gradient(
        color-mix(in srgb, var(--malachite-selection-bar-foreground) 16%, var(--malachite-selection-bar-background)),
        color-mix(in srgb, var(--malachite-selection-bar-foreground) 16%, var(--malachite-selection-bar-background))
    );
    color: var(--malachite-selection-bar-foreground);
}
.${PILL_BUTTON_CLASS}--secondary:hover:not(:disabled) {
    background-image: linear-gradient(
        color-mix(in srgb, var(--malachite-selection-bar-foreground) 30%, var(--malachite-selection-bar-background)),
        color-mix(in srgb, var(--malachite-selection-bar-foreground) 30%, var(--malachite-selection-bar-background))
    );
}
.${PILL_BUTTON_CLASS}--quiet {
    background-color: transparent;
    color: var(--malachite-selection-bar-foreground);
}
.${PILL_BUTTON_CLASS}--quiet:hover:not(:disabled) {
    background-image: linear-gradient(
        color-mix(in srgb, var(--malachite-selection-bar-foreground) 16%, var(--malachite-selection-bar-background)),
        color-mix(in srgb, var(--malachite-selection-bar-foreground) 16%, var(--malachite-selection-bar-background))
    );
}
`;

export const PILL_BUTTON_BASE = `${PILL_BUTTON_CLASS} inline-flex h-7 shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-[10px] border border-solid border-transparent px-[10px] text-[13px] font-medium disabled:cursor-not-allowed disabled:opacity-50 ${FOCUS_RING_SELECTION_BAR}`;

export const PILL_SURFACE =
    'flex items-center gap-2 rounded-2xl border border-solid border-[var(--malachite-selection-bar-border)] py-[6px] pl-[12px] pr-[6px] bg-[var(--malachite-selection-bar-background)] text-[var(--malachite-selection-bar-foreground)]';

export const PILL_SHADOW = 'var(--malachite-selection-bar-shadow)';

/** The sleeve a `notice` wraps the pill in: the pill keeps its own surface inside it. */
export const PILL_NOTICE_SLEEVE =
    'flex flex-col items-stretch gap-[2px] rounded-2xl p-[2px] bg-[var(--malachite-selection-bar-notice-background)]';

export const PILL_NOTICE_SHADOW = 'var(--malachite-selection-bar-notice-shadow)';

export const PILL_NOTICE_TEXT =
    'm-0 px-[12px] py-[8px] text-center text-[13px] font-medium leading-normal text-[var(--malachite-selection-bar-notice-foreground)]';

export const PILL_DIVIDER = 'shrink-0 select-none text-[13px]';

export const PILL_MUTED_TEXT = 'text-[var(--malachite-selection-bar-muted-foreground)]';
